/**
 * Machine-readable code the backend sends (as the GENERAL_ERROR message) to
 * signal that a visible puzzle must be solved. It is a stable contract, NOT
 * user-facing copy — we match on this exact value and render our own text.
 * Keep it in sync with the backend's RECAPTCHA_CHALLENGE_CODE.
 */
export const RECAPTCHA_CHALLENGE_CODE = "CAPTCHA_CHALLENGE_REQUIRED";
